// Only the public credential ID is stored, per Privy user; it narrows the passkey prompt and grants nothing.
const key = (privyUserId: string) => `gamma.wallet-passkey.v1:${privyUserId}`;

export const readRememberedPasskey = (privyUserId: string): string | null =>
  localStorage.getItem(key(privyUserId));

export const rememberPasskey = (privyUserId: string, credentialId: string): void =>
  localStorage.setItem(key(privyUserId), credentialId);

export const forgetRememberedPasskey = (privyUserId: string): void =>
  localStorage.removeItem(key(privyUserId));

export const forgetRemovedPasskey = (privyUserId: string, credentialId: string): void => {
  if (readRememberedPasskey(privyUserId) === credentialId) {
    forgetRememberedPasskey(privyUserId);
  }
};
